// 硬编码域名常量，避免依赖可能返回空值的函数
const MAIN_DOMAIN = {
  PROD: 'https://www.dolphinradar.com',
  TEST: 'https://www-test.dolphinradar.com',
};

const BLOG_DOMAIN = {
  PROD: 'https://blog.dolphinradar.com',
  TEST: 'https://blog-test.dolphinradar.com',
};

const HELP_DOMAIN = {
  PROD: 'https://support.dolphinradar.com',
  TEST: 'https://support-test.dolphinradar.com',
};

// 根据当前环境获取适当的域名
const getSiteDomain = (domainObj: typeof MAIN_DOMAIN) => {
  return process.env.NODE_ENV === 'production' && !process.env.NEXT_APP_API_HOST?.includes('-test.')
    ? domainObj.PROD
    : domainObj.TEST;
};

export const getMainDomain = () => getSiteDomain(MAIN_DOMAIN);
export const getBlogDomain = () => getSiteDomain(BLOG_DOMAIN);
export const getHelpDomain = () => getSiteDomain(HELP_DOMAIN);

export const isBlogWeb = () => {
  const url = new URL(process.env.NEXT_APP_WEB_HOST);
  const test_url = new URL('https://blog-test.dolphinradar.com');
  const prod_url = new URL('https://blog.dolphinradar.com');
  return url.host === test_url.host || url.host === prod_url.host;
};

export const isSupportWeb = () => {
  const url = new URL(process.env.NEXT_APP_WEB_HOST);
  const test_url = new URL('https://support-test.dolphinradar.com');
  const prod_url = new URL('https://support.dolphinradar.com');
  return url.host === test_url.host || url.host === prod_url.host;
};
